/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatedApiResponse } from '../../models/created-api-response';
import { CreateUserCommand } from '../../models/create-user-command';

export interface CreateUserAsync$Plain$Params {
      body?: CreateUserCommand
}

export function createUserAsync$Plain(http: HttpClient, rootUrl: string, params?: CreateUserAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatedApiResponse>> {
  const rb = new RequestBuilder(rootUrl, createUserAsync$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatedApiResponse>;
    })
  );
}

createUserAsync$Plain.PATH = '/api/user';
